// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__7Cfri","footer":"ModalInfo_footer__2JL3H"};